export const UserSearchGlasIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <circle cx={10.5} cy={10.5} r={10} fill="#00C4B8" />
      <path d="M3.429,17.571A10,10,0,0,1,17.571,3.429Z" fill="#c4f0eb" />
      <circle
        cx={10.5}
        cy={10.5}
        r={10}
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={23.5}
        y1={23.5}
        x2={17.571}
        y2={17.571}
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.322,13.19a6.34,6.34,0,0,0,3.746-.783.5.5,0,0,0,.142-.751c-.433-.508-.733-1.178-.866-3.133C15.093,4.807,12.587,3.5,10.433,3.5S5.774,4.807,5.522,8.523c-.132,1.955-.432,2.625-.865,3.133a.5.5,0,0,0,.142.751,6.343,6.343,0,0,0,3.745.783"
        fill="#dff9ff"
      />
      <path
        d="M16.21,11.656c-.433-.508-.733-1.178-.866-3.133C15.093,4.807,12.587,3.5,10.433,3.5S5.774,4.807,5.522,8.523c-.132,1.955-.432,2.625-.865,3.133a.5.5,0,0,0,.142.75c.172.1.344.188.517.269a12,12,0,0,0,.206-1.652C5.774,7.307,8.28,6,10.433,6s4.66,1.307,4.911,5.023a12.3,12.3,0,0,0,.206,1.652,5.557,5.557,0,0,0,.518-.269A.5.5,0,0,0,16.21,11.656Z"
        fill="#ffffff"
      />
      <path
        d="M12.322,13.19a6.34,6.34,0,0,0,3.746-.783.5.5,0,0,0,.142-.751c-.433-.508-.733-1.178-.866-3.133C15.093,4.807,12.587,3.5,10.433,3.5S5.774,4.807,5.522,8.523c-.132,1.955-.432,2.625-.865,3.133a.5.5,0,0,0,.142.751,6.343,6.343,0,0,0,3.745.783"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.776,15.716c-.853-.352-1.862-.713-2.959-1.119a.759.759,0,0,1-.5-.709v-1.38a.754.754,0,0,1,.247-.559,2.717,2.717,0,0,0,.887-2.027v-1.1a.989.989,0,0,0-.7-.946,4.9,4.9,0,0,1-1.986-1.181.494.494,0,0,0-.679,0A4.9,4.9,0,0,1,8.108,7.873a.988.988,0,0,0-.7.946v1.1A2.722,2.722,0,0,0,8.3,11.949a.754.754,0,0,1,.247.559v1.38a.759.759,0,0,1-.5.709c-1.1.406-2.1.767-2.958,1.119"
        fill="#ffffff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
